// src/components/Auth/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3057/api';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({ email, password, rememberMe }),
      });

      const data = await response.json();

      if (data.success) {
        if (rememberMe) {
          localStorage.setItem('auth_token', data.token);
          localStorage.setItem('user_email', data.user.email);
        } else {
          sessionStorage.setItem('auth_token', data.token);
          sessionStorage.setItem('user_email', data.user.email);
        }

        navigate('/globe');
      } else {
        setError(data.error || 'Erro ao fazer login');
      }
    } catch (err) {
      setError('Erro de conex&atilde;o. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        {/* Lado esquerdo - Formul�rio */}
        <div className="login-left">
          <div className="login-box">
            {/* Logo Uber */}
            <div className="uber-logo">
              <img src="/assets/images/uber-logo.png" alt="Uber" />
            </div>

            {/* Logo STATS Protocol */}
            <div className="stats-logo">
              <div className="stats-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3 13h2v8H3zm4-8h2v16H7zm4-2h2v18h-2zm4-2h2v20h-2zm4 4h2v16h-2z" />
                </svg>
              </div>
              <div>
                <h1>STATS Protocol</h1>
              </div>
            </div>

            {/* Mensagem de erro */}
            {error && (
              <div className="error-message">
                <svg viewBox="0 0 24 24" fill="currentColor" className="error-icon">
                  <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
                </svg>
                <div className="error-content">
                  <p className="error-title">Erro de autentica&ccedil;&atilde;o</p>
                  <p className="error-text">{error}</p>
                </div>
              </div>
            )}

            {/* Formul�rio */}
            <form onSubmit={handleSubmit} className="login-form">
              <div className={`form-group ${focusedField === 'email' ? 'focused' : ''}`}>
                <label htmlFor="email">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="2" y="4" width="20" height="16" rx="2" />
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                  </svg>
                  Email Corporativo
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onFocus={() => setFocusedField('email')}
                  onBlur={() => setFocusedField(null)}
                  required
                  placeholder="seu.email@uber.com"
                  autoComplete="email"
                />
              </div>

              <div className={`form-group ${focusedField === 'password' ? 'focused' : ''}`}>
                <label htmlFor="password">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                    <circle cx="12" cy="16" r="1" />
                  </svg>
                  Senha
                </label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onFocus={() => setFocusedField('password')}
                  onBlur={() => setFocusedField(null)}
                  required
                  placeholder="��������"
                  autoComplete="current-password"
                />
              </div>

              {/* Checkbox */}
              <div className="form-group checkbox-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="checkbox-input"
                  />
                  <span className="checkbox-custom">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </span>
                  <span className="checkbox-text">Manter-me conectado</span>
                </label>
              </div>

              {/* Bot�o de login */}
              <button 
                type="submit" 
                disabled={loading} 
                className="login-button"
              >
                <span className="button-content">
                  {loading ? (
                    <>
                      <span className="spinner"></span>
                      Entrando...
                    </>
                  ) : (
                    <>
                      Acessar Dashboard
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="button-icon">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </>
                  )}
                </span>
              </button>

            </form>

            {/* Footer */}
            <div className="login-footer">
              <p>Powered by <strong>STATS Protocol</strong></p>
            </div>
          </div>
        </div>

        {/* Lado direito - Informa��es */}
        <div className="login-right">
          <div className="info-panel">
            <div className="info-content">
              <h2>Bem-vindo ao STATS Protocol</h2>
              <p>A plataforma de an&aacute;lise mais avan&ccedil;ada para empresas que buscam intelig&ecirc;ncia de dados em tempo real.</p>
              
              <div className="features-list">
                <div className="feature-item">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3 13h2v8H3zm4-8h2v16H7zm4-2h2v18h-2zm4-2h2v20h-2zm4 4h2v16h-2z" />
                  </svg>
                  <span>Dashboards em Tempo Real</span>
                </div>
                <div className="feature-item">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5z" />
                  </svg>
                  <span>An&aacute;lises Profundas</span>
                </div>
                <div className="feature-item">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                  <span>Performance Otimizada</span>
                </div>
                <div className="feature-item">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5s-5 2.24-5 5v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" />
                  </svg>
                  <span>Seguran&ccedil;a Empresarial</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
